export default __webpack_public_path__ + "static/ak-cached/24h/media/mdl-cls.fd168576.svg";